/**
 * Click tabs — "A home base designed around the owner" (Single service, TZ section 8):
 * a click on a tab swaps the photo + content (CSS fade via .is-active). ←/→/Home/End move between tabs.
 * Mobile/tablet: the tab bar scrolls horizontally → the chosen tab is scrolled into view.
 */
export const clickTabs = () => {
    return new Promise((resolve) => {
        document.querySelectorAll('.click-tabs').forEach((section) => init(section));
        resolve();
    });
};

const init = (section) => {
    const nav = section.querySelector('.click-tabs__nav');
    const tabs = [...section.querySelectorAll('.click-tabs__tab')];
    const panels = [...section.querySelectorAll('.click-tabs__panel')];
    if (!nav || tabs.length < 2) return;

    const activate = (index, focus = false) => {
        tabs.forEach((tab, i) => {
            const isActive = i === index;
            tab.classList.toggle('is-active', isActive);
            tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
            tab.tabIndex = isActive ? 0 : -1;
        });
        panels.forEach((panel, i) => {
            const isActive = i === index;
            panel.classList.toggle('is-active', isActive);
            panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });

        const tab = tabs[index];
        if (focus) tab.focus({preventScroll: true});

        // keep the chosen tab visible in the scrollable bar (mobile)
        if (nav.scrollWidth > nav.clientWidth) {
            const left = tab.offsetLeft - (nav.clientWidth - tab.offsetWidth) / 2;
            nav.scrollTo({left, behavior: 'smooth'});
        }
    };

    tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => activate(i));
        tab.addEventListener('keydown', (e) => {
            const keys = {ArrowRight: i + 1, ArrowLeft: i - 1, Home: 0, End: tabs.length - 1};
            if (!(e.key in keys)) return;
            e.preventDefault();
            activate((keys[e.key] + tabs.length) % tabs.length, true);
        });
    });
};
